module.exports = __webpack_public_path__ + "img/alert.3c7b1a19.svg";